import { memo } from 'react';

import { FooterOC } from './FooterOC';

export * from './FooterOC';

export default memo(FooterOC);
